import { WebMercatorViewport } from "@deck.gl/core";
import { bbox } from "@turf/turf";
import type { GeoJSON } from "geojson";

import type { ViewportType } from "~/lib/map/types";

const FIT_PADDING = 32;
const POINT_ZOOM = 8;

export const getFittedViewStateFromGeoJson = (
  geoJson: GeoJSON,
  width: number,
  height: number,
): Partial<ViewportType> | undefined => {
  const [west, south, east, north] = bbox(geoJson);
  if (![west, south, east, north].every(Number.isFinite)) {
    return undefined;
  }

  if (west === east && south === north) {
    return { longitude: west, latitude: south, zoom: POINT_ZOOM, minZoom: 0 };
  }

  const viewport = new WebMercatorViewport({ width, height }).fitBounds(
    [
      [west, south],
      [east, north],
    ],
    { padding: FIT_PADDING, maxZoom: POINT_ZOOM },
  );

  return {
    longitude: viewport.longitude,
    latitude: viewport.latitude,
    zoom: viewport.zoom,
    minZoom: 0,
  };
};
